import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  color: 'brandGray.700',
});
export const headingTheme = defineStyleConfig({
  baseStyle,
});
